import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import Swiper, { Autoplay } from 'swiper';

import 'swiper/swiper-bundle.min.css';

class BannerSwiper extends React.PureComponent {
    componentDidMount() {
        const videoSwiper = new Swiper('#pw_swiper', {
            loop: true,
            autoplay: true,
        });

        Autoplay.create.call(videoSwiper);

        setInterval(() => {
            videoSwiper.autoplay.run();
        }, 3000);
    }

    componentDidUpdate() {
        this.videoSwiper = new Swiper('#pw_swiper', {
            loop: false,
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
            },
        });
    }

    render() {
        return (
            <div className={styles.BannerSwiperContainer} id="pw_swiper">
                <div className={`swiper-wrapper ${styles.listOuter}`}>
                    <div className={`swiper-slide ${styles.list}`}>
                        <img
                            src="http://p3.ifengimg.com/a/2017/1013/logo_5351d7af.jpg"
                            title="大美中国"
                            alt="大美中国"
                        />
                    </div>
                    <div className={`swiper-slide ${styles.list}`}>
                        <img
                            src="https://x0.ifengimg.com/ucms/2021_14/513FC8DEE65822DD8AC6E37B8CF50CCC6B039747_size296_w1000_h220.jpg"
                            title="大美中国"
                            alt="大美中国"
                        />
                    </div>
                </div>
                <div className="swiper-pagination" />
            </div>
        );
    }
}

export default errorBoundary(BannerSwiper);
